/**
 * Creates a content octopus component.
 * @param {object} properties - The component props object.
 * @param {string} [properties.className] - A string of classes to be applied to the main element.
 * @returns {import('react').ReactElement<{ className: string }>} The ContentOctopus.
 */
export function ContentOctopus({ className }) {
  return (
    <div className={className}>
      <svg width="234" height="258" viewBox="0 0 234 258" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M171.149 160.483C190.784 144.059 203.363 118.778 203.363 90.4208C203.363 40.9196 165.031 0.790955 117.746 0.790955C70.461 0.790955 32.1289 40.9196 32.1289 90.4208C32.1289 118.074 44.0918 142.803 62.8954 159.244C59.3126 163.912 54.8722 168.949 49.7687 173.578C39.9238 182.509 29.0439 188.643 18.2598 189.534C10.4062 190.183 4.57011 197.024 5.22458 204.813C5.87905 212.602 12.7762 218.39 20.6299 217.741C37.4251 216.353 51.99 208.384 63.4475 199.224C59.3836 205.77 55.4357 211.845 51.9005 216.868C47.6713 222.877 44.731 226.357 43.2603 227.654C37.3701 232.847 36.8395 241.792 42.0753 247.633C47.311 253.475 56.3304 254.001 62.2206 248.809C66.4577 245.073 71.0617 239.093 75.3018 233.069C79.7728 226.717 84.6409 219.14 89.4235 211.353C93.6891 204.407 97.9525 197.186 101.891 190.348V242.949C101.891 250.765 108.28 257.101 116.161 257.101C124.041 257.101 130.43 250.765 130.43 242.949V189.57C134.771 197.775 139.573 206.461 144.388 214.536C149.21 222.623 154.23 230.412 158.952 236.563C161.304 239.627 163.794 242.565 166.339 245.004C168.598 247.168 172.13 250.161 176.654 251.657C184.13 254.129 192.211 250.122 194.704 242.707C197.066 235.679 193.559 228.112 186.821 225.237C186.669 225.11 186.452 224.919 186.169 224.648C185.055 223.581 183.542 221.871 181.659 219.418C177.912 214.536 173.538 207.819 168.953 200.129C168.693 199.694 168.434 199.256 168.174 198.817C178.8 207.063 192.277 213.446 208.689 214.609C216.55 215.165 223.377 209.297 223.939 201.501C224.5 193.705 218.583 186.933 210.722 186.376C197.533 185.442 186.947 178.863 178.695 170.061C175.801 166.974 173.287 163.704 171.149 160.483Z"
          fill="#91CDE8"
        />
        <path
          d="M210.903 145.297C217.581 140.996 226.46 142.957 230.734 149.678C235.008 156.399 233.059 165.334 226.381 169.635C217.655 175.255 209.165 178.706 201.095 180.525C188.333 178.423 178.762 164.812 175.572 160.677L183.548 153.072C191.434 153.656 200.755 151.833 210.903 145.297Z"
          fill="#91CDE8"
        />
        <path
          d="M3.04808 150.025C7.12747 143.183 15.9461 140.964 22.7451 145.069C32.8591 151.176 43.2534 153.472 52.7505 153.625L58.4284 159.064C54.9028 164.263 43.9053 175.831 34.5008 180.508C25.7965 178.591 16.8469 175.206 7.97234 169.848C1.17336 165.742 -1.03131 156.867 3.04808 150.025Z"
          fill="#91CDE8"
        />
        <path
          d="M139.318 89.5933C147.182 86.1356 155.127 86.6289 159.711 95.8324"
          stroke="#001657"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M91.2171 88.7702C84.0307 83.6964 75.831 83.1688 69 93.152"
          stroke="#001657"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M154.802 109.992C154.5 102 150.5 99.5 145.925 99C141.528 98.5194 137.805 100.339 136.872 104.915C136.747 105.529 137.275 106.053 137.901 106.025C138.265 106.008 138.632 106 139 106C144.333 106 149.26 107.739 153.244 110.682C153.882 111.153 154.802 110.785 154.802 109.992Z"
          fill="#001657"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M74.1091 108.421C73.7064 108.735 73.1092 108.485 73.1092 107.975C73.1092 101.561 77.0001 97.5 81.9866 96.7319C86.5807 96.0243 90.2567 98.2773 91.0889 103.128C91.2003 103.777 90.603 104.297 89.9506 104.206C88.9866 104.07 88.0015 104 87 104C82.141 104 77.6674 105.65 74.1091 108.421Z"
          fill="#001657"
        />
        <path
          d="M105.73 142.456C108 149.5 118.5 151 123.195 143.558"
          stroke="#001657"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}

export default ContentOctopus;
